import LangCache from '../base/langCache';
import { changeLanguage } from '../dataServices/changeLanguage';

export function getLangText(text: string): string {
    const LANG = LangCache.getLang();
    const langText = LANG[text] || '';
    return langText;
}

/**
 * 设置系统语言偏好
 * @param {string}    lang     zh-cn 等
 * @param {Function}  callback 设置完成后的回调函数
 */
export const setSiteLang = (lang: string, siteHost: string) => {
    const date = new Date();
    date.setFullYear(date.getFullYear() + 10);
    document.cookie = `_lang=${lang};expires=${date.toUTCString()};domain=${siteHost};path=/;`;

    return changeLanguage(lang);
};
